import axios from "../axiosInstance";

class DirectMessageReasonService {
  async listDirectMessageReasons() {
    return axios.get("directMessageReason");
  }
}

export default new DirectMessageReasonService();
